import { useEffect } from 'react'
import { metaMask } from './metamask'

export function useEagerConnect() {
  useEffect(() => {
    metaMask.connectEagerly()
  }, [])
}
